import { jsx, Fragment } from 'react/jsx-runtime';
import { createPortal } from 'react-dom';
import { LazyMotion, domAnimation, AnimatePresence, m } from 'framer-motion';

const ANIMATE_DURATION = 0.4;
const EASE_FUNCTION = [
    0.04,
    0.62,
    0.23,
    0.98
];
const SideSheetPortal = ({ children, isOpen })=>{
    if (typeof document === 'undefined') {
        return;
    }
    return jsx(Fragment, {
        children: /*#__PURE__*/ createPortal(jsx(LazyMotion, {
            features: domAnimation,
            children: jsx(AnimatePresence, {
                initial: false,
                children: isOpen && jsx(m.div, {
                    animate: "open",
                    "aria-labelledby": "side-sheet-title",
                    "aria-modal": "true",
                    className: "cb-side-sheet-portal",
                    "data-testid": "side-sheet-portal",
                    exit: "collapsed",
                    initial: "collapsed",
                    role: "dialog",
                    transition: {
                        duration: ANIMATE_DURATION,
                        ease: EASE_FUNCTION
                    },
                    variants: {
                        open: {
                            x: 0
                        },
                        collapsed: {
                            x: '100%'
                        }
                    },
                    children: children
                }, "content")
            })
        }), document.body)
    });
};

export { SideSheetPortal, SideSheetPortal as default };
//# sourceMappingURL=SideSheetPortal.es.js.map
